import { getBrand, type BrandConfig } from '~~/app/brands'

/**
 * Jedyne źródło prawdy o tożsamości marki. Czyta runtimeConfig.public.brand
 * (env NUXT_PUBLIC_BRAND) i zwraca odpowiedni preset; fallback na LAVMAG.
 * Czysta funkcja nad runtimeConfig — identyczna SSR i klient.
 */
export function useBrand(): BrandConfig {
  const brand = useRuntimeConfig().public.brand as string | undefined
  return getBrand(brand)
}
